import { Pipe, PipeTransform } from "@angular/core";
import { AssetHistoryDocumentStatus } from '@app/_models/enums/assetHistoryDocumentStatus';
import { Document } from '@app/_models/_DTOs/document';

@Pipe({
    name: 'sortDocuments',
    pure: true
})
export class SortDocuments implements PipeTransform {
    transform(value: Document[], args?: any): any {
        if(value && value.length > 0){
            return value.sort((val1, val2) => { return new Date(val2.created).getTime() - new Date(val1.created).getTime() })
        }
        return [];
    }
}